'use strict';

const _ = require('lodash');
const Enum = require('./enum.js');

/**
 * Create an enum from the values of the enumerable properties of an object
 *
 * @param {object} o an object
 * @returns {Enum} an Enum
 */
function enumFromObject(o) {
  return Object.create(
    Enum,
    // eslint-disable-next-line security/detect-object-injection
    _.transform(o, (result, value, key) => (result[key] = { value, enumerable: true }))
  );
}

module.exports = enumFromObject;
